export default __webpack_public_path__ + "static/serious-tissues-4d05611ee3aa9371d0f4d6fe484a8aed.jpg";